import { IMattressMatchResults } from "../../models/catalogue";
import { IReduxState } from "./reducers.interfaces";

export const mostSimilarProducts = (
    state: IReduxState,
): IMattressMatchResults | null => {
    if (!state.ui.loadedResults) {
        return null;
    }
    return state.ui.loadedResults;
};
